module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei3.svg";